var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Dialog, DialogContent, DialogHeader, UnsafeHTML, TypographyStyler, Image, Stacker, } from '@honeycomb/ui-core';
export function RoomDetailsDialog(_a) {
    var { room } = _a, other = __rest(_a, ["room"]);
    return room ? (React.createElement(Dialog, Object.assign({ size: "l" }, other),
        React.createElement(DialogHeader, { "data-id": "room-details-dialog", withCloseButton: true, border: false }, room.title),
        React.createElement(DialogContent, { pb: 4 },
            React.createElement(Stacker, { spacing: 5 },
                room.imageUrl && React.createElement(Image, { src: room.imageUrl, withPlaceholder: true, w: "100%", h: "275px" }),
                React.createElement(TypographyStyler, null,
                    React.createElement(UnsafeHTML, null, room.description)))))) : null;
}
